import { useIntl } from '@edx/frontend-platform/i18n';
import { Link } from 'react-router-dom';

import logistrationMessages from '../../messages';

const FooterLinks = () => {
  const intl = useIntl();

  return (
    <footer className="auth-footer">
      <Link
        className="link-block"
        to="/terms-of-use"
        target="_blank"
      >
        {intl.formatMessage(logistrationMessages.tosLinkText)}
      </Link>
      <span className="auth-footer-separator" />
      <Link
        className="link-block"
        to="/privacy-policy"
        target="_blank"
      >
        {intl.formatMessage(logistrationMessages.privacyLinkText)}
      </Link>
    </footer>
  );
};

export default FooterLinks;
